import { Injectable } from '@angular/core';
import { JsonFileExporter } from 'json-file-exporter/src';
import { IJSONFileExporter } from './json-file-exporter.interface';
import { ExportJSONFileModel } from './models/export-file.model';

@Injectable()
export class IosFileExporter implements IJSONFileExporter {
	public async exportFile(file: ExportJSONFileModel) {
		await JsonFileExporter.exportFile({ value: file });
	}
}
